/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZerogDelegatorValidatorListRequest = {
    delegator?: string;
    sortField?: ZerogDelegatorValidatorListRequest.sortField;
    sortDirection?: ZerogDelegatorValidatorListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace ZerogDelegatorValidatorListRequest {

    export enum sortField {
        ELIGIBLE_TOKEN_AMOUNT = 'ELIGIBLE_TOKEN_AMOUNT',
        COMMISSION = 'COMMISSION',
        APY = 'APY',
        DELEGATED_AT = 'DELEGATED_AT',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

